import moment from 'moment'

export default {
  debitMultiple (inventoryView, required) {
    // inventoryView = [{id: ?, inventory_item_id: ?, quantity: ?, expiry_date: ?}, ...]
    // required = {inventory_item_id: quantity, ...}
    var map = {}
    for (const [inventory_item_id, quantity] of Object.entries(required)) {
      map[inventory_item_id] = this.debitItem(inventoryView, parseInt(inventory_item_id), quantity)
    }
    return map
  },
  debitItem (_inventoryView, inventory_item_id, required) {
    // required = Number
    // inventoryView (can be array or object) = [{id: ?, inventory_item_id: ?, quantity: ?}] OR {id: [{id: ?, inventory_item_id: ?, quantity: ?}], id: [{id: ?, inventory_item_id: ?, quantity: ?}]}
    // this can also be called to map a single inv item
    var map = {}
    var remaining = required
    var inventoryView = JSON.parse(JSON.stringify(_inventoryView)) // make a copy so sorting doesnt cause infinitate update loops in components
    var inventory
    if (Array.isArray(inventoryView)) {
      inventory = inventoryView.filter(invItem => invItem.inventory_item_id === inventory_item_id)
    } else {
      inventory = inventoryView[inventory_item_id] || []
    }
    // sort inventory
    inventory.sort((a, b) => {
      return new Date(a.expiry_date) - new Date(b.expiry_date)
    })
    // dont use expired batches but allow null or '0000-00-00' type dates through
    inventory = this.getUnexpired(inventory)

    // And now we loop fill
    for (var invItem of inventory) {
      if (invItem.quantity >= remaining) { // if item has more quantity than what is required
        map[invItem.id] = remaining
        remaining -= remaining
      } else {
        map[invItem.id] = invItem.quantity
        remaining -= invItem.quantity
      }
      // break out if completely filled
      if (remaining <= 0) {
        break
      }
    }
    return map
  },
  getUnexpired (_items) { // [{ expiry_date: ?}]
    // dont use expired batches but allow null or '0000-00-00' type dates through
    return _items.filter(item => !moment(item.expiry_date).isValid() || moment.utc(item.expiry_date).isAfter())
  },
  reduceDebitMap (map) {
    // this converts the following
    // {250: {120: 0}, 12: {}, 13: {1: 1}}
    // into
    // {13: {1: 1}}
    var reduced = JSON.parse(JSON.stringify(map))
    for (const [key, value] of Object.entries(reduced)) {
      for (const [key2, value2] of Object.entries(value)) {
        if (value2 === 0) {
          delete reduced[key][key2]
        }
      }
      if (_.isEqual(value, {})) {
        delete reduced[key]
      }
    }
    return reduced
  },
  mergeMapMultipleNew (inventoryView, savedInputs) {
    var map = {}
    var aidMap = this.mergeMapAidInvid(inventoryView, savedInputs)
    for (var savedInput of savedInputs) {
      map[savedInput.id] = aidMap[savedInput.archive_id]
    }
    return map
  },
  mergeMapAidInvid (inventoryView, savedInputs) {
    // NEW
    // The new version of this function can merge duplicate savedInputs into the same id

    // inventoryView = [{id: ?, inventory_item_id: ?, archive_id: ?}, ...]
    // savedInputs = [{id: ?, inventory_item_id: ?, archive_id: ?}, ...]
    var aidMap = {} // {archive_id: map_to_inv_id}
    var idGenerator = 0
    for (var mergeItem of savedInputs) {
      // check if there is a matching archive_id in Inventory
      var inventory = inventoryView.filter(item => {
        return item.archive_id === mergeItem.archive_id
      })
      // if theres a matching inv item to re-add the stock to
      if (inventory.length > 0) {
        if (!aidMap[mergeItem.archive_id]) {
          aidMap[mergeItem.archive_id] = inventory[0].id
        }
      } else { // else generate a negative id
        if (!aidMap[mergeItem.archive_id]) {
          idGenerator -= 1
          aidMap[mergeItem.archive_id] = idGenerator
        }
      }
    }
    return aidMap
  },
  mergeMapMultiple (inventoryView, mergeItems) {
    // inventoryView = [{id: ?, inventory_item_id: ?, archive_id: ?}, ...]
    // mergeItems = [{id: ?, inventory_item_id: ?, archive_id: ?}, ...]
    var map = {}
    var idGenerator = 0
    for (var mergeItem of mergeItems) {
      // check if there is a matching archive_id in Inventory
      var match = inventoryView.find(item => {
        return item.archive_id === mergeItem.archive_id
      })
      // if theres a matching inv item to re-add the stock to
      if (match) {
        map[mergeItem.id] = match.id
      } else {
        idGenerator -= 1
        map[mergeItem.id] = idGenerator
      }
    }
    return map
  },
  mergeDebitsBackToInventory (inventory, debitTable, mergeMap) {
    var newInventory = JSON.parse(JSON.stringify(inventory))
    var invMap = newInventory.reduce((a, i) => {
      a[i.id] = i
      return a
    }, {})
    for (var debit of debitTable) {
      var invMergeId = mergeMap[debit.id]
      var invItem = invMap[invMergeId]
      if (invItem) {
        invItem.quantity += debit.quantity
      } else {
        // recreate the missing item in inventory
        /* invMap[invMergeId] = {
          id: invMergeId,
          inventory_item_id: debit.inventory_item_id,
          archive_id: debit.archive_id,
          quantity: debit.quantity
        } */
        invMap[invMergeId] = Object.assign({}, debit, {
          id: invMergeId,
          inventory_item_id: debit.inventory_item_id,
          archive_id: debit.archive_id,
          quantity: debit.quantity
        })
      }
    }
    return Object.values(invMap)
  }
}